import { render, staticRenderFns } from "./columns-item.vue?vue&type=template&id=dba69106&scoped=true&"
import script from "./columns-item.vue?vue&type=script&lang=js&"
export * from "./columns-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba69106",
  null
  
)

export default component.exports